import styled, { css } from 'styled-components'

export const Content = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${theme.spacings.small};
    margin: ${theme.spacings.xsmall} 0;
  `}
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
